/**
 * @author 3173
 * @date 2020-09-23
 * @desc 系列化查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority } from "../../../common";

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizForm, Wizmessage, WizRow, WizCol, WizInput, WizSpin } = component_tool
let { Session } = utils_tool

class SeriesInfo extends WizContainer {
  componentName = 'seriesInfo'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location) {
      if (history.location.pathname === '/series/seriesList/seriesInfo'
          || history.location.pathname === '/interact/activity/activityDetailToPart/activityPartLook/toSeries') {
        if(history.location.record) {
          detailInfo = history.location.record
          Session.set('seriesInfo', detailInfo)
        } else {
          detailInfo = Session.get('seriesInfo') || {}
        }
      }
    }
    this.state = {
      time: undefined
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo.id) {
      this.doAction({
        path: 'series/getSeriesInfo',
        payload: {
          key: 'getSeriesInfo',
          apiParams: {
            id: this.detailInfo.id
          }
        }
      })
    }
  }

  propsAndStateOnChange = {
    getSeriesInfo: this._getSeriesInfoOver.bind(this)
  }

  _getSeriesInfoOver(nextProps, nextState) {
    if (nextProps.getSeriesInfo.code == 1) {
      this.detailInfo = nextProps.getSeriesInfo.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }


  authorityInfo = () => {
    return (
      <WizAuthority value={this.detailInfo.authData} mode='Show' showBlock={false} />
    )
  }

  onerror() {

  }

  getImgInfo = () => {
    let record = this.detailInfo
    if (record && record.img) {
      let url = getOssFilePath(record.img)
      // ossFileUtils.getOssFile(
      //   record.img,
      //   record.fileName,
      //   record.fileMimeType,
      //   record.fileSize,
      //   record.fileUri,
      // ).url
      url = record.img ? url : constants.files.sys_img_loadingFailed;
      return <div style={{ display: 'flex', 'justify-content': 'flex-start', marginRight: 0, }}>
        <div>
          <img height={225} width={400} src={url} />
        </div>
      </div>
    }
  }


  _render() {
    const items = this.detailInfo
    items['state'] == 0 ? items['state'] = "无效" : items['state'] == 1 ? items['state'] = "有效" : ''


    return (
      <React.Fragment>
        <WizSpin tip={'加载中'} spinning={this.props.seriesLoading}>
          <WizCard>
            <Descriptions column={1} bordered={true}>
              <Descriptions.Item label='名称'>{items.name}</Descriptions.Item>
              <Descriptions.Item label='封面'>{this.getImgInfo()}</Descriptions.Item>
              <Descriptions.Item label='简介'>{items.intro}</Descriptions.Item>
              <Descriptions.Item label='分类'>{items.seriesCategoryName}</Descriptions.Item>
              <Descriptions.Item label='受众'>{this.authorityInfo()}</Descriptions.Item>
              <Descriptions.Item label='状态'>{items.state}</Descriptions.Item>
            </Descriptions>
          </WizCard>
        </WizSpin>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { series } = state;
  const getSeriesInfo = modelUtils.getModelEntity(series, 'getSeriesInfo');
  const load = modelUtils.getLoadingState(state, 'series');
  return {
    getSeriesInfo,
    ...load
  }
};

export default connect(mapStateToProps)(SeriesInfo)

